import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { UserPlus } from "lucide-react";

export function ClaimHelpPanel({ conversation, messages, me }) {
  const [bookings, setBookings] = useState([]);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const help = [...messages].reverse().find((m) => m.content?.startsWith("Bonjour, je ne retrouve pas mon séjour"));
  const checkIn = help?.content.match(/Date d'arrivée : (\d{4}-\d{2}-\d{2})/)?.[1];
  const guestId = conversation.participants.find((p) => p !== me.user_id);
  const guestName = conversation.participant_names?.[guestId] || "le client";

  useEffect(() => {
    if (!checkIn) return;
    api.get("/bookings/by-date", { params: { check_in: checkIn } }).then(({ data }) => setBookings(data)).catch(() => setBookings([]));
  }, [checkIn]);

  if (!help || !checkIn || done) return null;

  const assign = async (booking_id) => {
    setBusy(true);
    try {
      await api.post(`/bookings/${booking_id}/assign`, { user_id: guestId });
      await api.post(`/conversations/${conversation.conversation_id}/messages`, { content: "C'est fait : votre séjour est maintenant associé à votre compte. Retrouvez-le dans « Mes séjours ». À très bientôt !" });
      toast.success("Séjour associé et client prévenu"); setDone(true);
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="mx-5 mt-3 rounded-xl border border-rose-brand/40 bg-rosebrand-pale/40 p-3" data-testid="claim-help-panel">
      <p className="text-xs font-semibold text-rose-brand flex items-center gap-1"><UserPlus className="w-3.5 h-3.5" /> Séjours arrivant le {checkIn} — associer à {guestName}</p>
      {bookings.length === 0 && <p className="text-xs text-muted-foreground mt-1">Aucune réservation à cette date. Vérifiez la date avec le client.</p>}
      <div className="mt-2 space-y-1.5">
        {bookings.map((b) => (
          <div key={b.booking_id} className="flex items-center justify-between gap-2 text-sm" data-testid={`help-booking-${b.booking_id}`}>
            <span className="truncate"><strong className="text-olive">{b.listing_title}</strong> · {b.traveler_name}{b.traveler_id ? <span className="text-xs text-muted-foreground"> (déjà associé)</span> : ""}</span>
            <Button size="sm" disabled={busy || b.traveler_id === guestId} onClick={() => assign(b.booking_id)} className="bg-olive text-white h-7 text-xs shrink-0" data-testid={`help-assign-${b.booking_id}`}>Associer ce séjour</Button>
          </div>
        ))}
      </div>
    </div>
  );
}
